import { render, staticRenderFns } from "./Lgx202142297964412928.vue?vue&type=template&id=68541bf4&"
import script from "./Lgx202142297964412928.vue?vue&type=script&lang=js&"
export * from "./Lgx202142297964412928.vue?vue&type=script&lang=js&"
import style0 from "./Lgx202142297964412928.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports